module.exports = __webpack_public_path__ + "static/media/pdf100.ce289357.jpg";